import { createSlice } from "@reduxjs/toolkit";
import {
  getGroupRules,
  updateGroupRules,
} from "../actions/fluxoNSimilar";
import { GetGroupRulesResponse } from "../../types/gruposResponsabilidade";

type RequestStatus = "idle" | "loading" | "ready" | "error";
type SavingStatus = "idle" | "saving" | "success" | "error";

interface GroupRulesState {
  rulesByGroupId: Record<string, GetGroupRulesResponse>;
  statusByGroupId: Record<string, RequestStatus>;
  errorByGroupId: Record<string, unknown>;
  savingStatusByGroupId: Record<string, SavingStatus>;
  savingErrorByGroupId: Record<string, unknown>;
}

const initialState: GroupRulesState = {
  rulesByGroupId: {},
  statusByGroupId: {},
  errorByGroupId: {},
  savingStatusByGroupId: {},
  savingErrorByGroupId: {},
};

const sessionGroupRulesSlice = createSlice({
  name: "sessionGroupRules",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGroupRules.pending, (state, action) => {
        const groupId = action.meta.arg;
        state.statusByGroupId[groupId] = "loading";
        delete state.errorByGroupId[groupId];
      })
      .addCase(getGroupRules.fulfilled, (state, action) => {
        const groupId = action.payload.groupId || action.meta.arg;
        state.statusByGroupId[groupId] = "ready";
        state.rulesByGroupId[groupId] = action.payload;
        delete state.errorByGroupId[groupId];
      })
      .addCase(getGroupRules.rejected, (state, action) => {
        const groupId = action.meta.arg;
        state.statusByGroupId[groupId] = "error";
        state.errorByGroupId[groupId] = action.payload ?? action.error;
      })
      .addCase(updateGroupRules.pending, (state, action) => {
        const groupId = action.meta.arg.groupId;
        state.savingStatusByGroupId[groupId] = "saving";
        delete state.savingErrorByGroupId[groupId];
      })
      .addCase(updateGroupRules.fulfilled, (state, action) => {
        const groupId = action.meta.arg.groupId;
        state.savingStatusByGroupId[groupId] = "success";
        delete state.savingErrorByGroupId[groupId];
      })
      .addCase(updateGroupRules.rejected, (state, action) => {
        const groupId = action.meta.arg.groupId;
        state.savingStatusByGroupId[groupId] = "error";
        state.savingErrorByGroupId[groupId] = action.payload ?? action.error;
      });
  },
});

export default sessionGroupRulesSlice.reducer;